"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomInternalTemplateType = void 0;
var CustomInternalTemplateType;
(function (CustomInternalTemplateType) {
    CustomInternalTemplateType["LICENSE"] = "license";
    CustomInternalTemplateType["USER"] = "user";
})(CustomInternalTemplateType = exports.CustomInternalTemplateType || (exports.CustomInternalTemplateType = {}));
